import { render, staticRenderFns } from "./fragment-html.vue?vue&type=template&id=1d5c63b7&scoped=true&"
import script from "./fragment-html.vue?vue&type=script&lang=js&"
export * from "./fragment-html.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5c63b7",
  null
  
)

export default component.exports